import type { I18n } from '@lingui/core'

import { TENANT_AT, TENANT_COM, TENANT_FR, TENANT_IT } from 'shared/consts'

export const getPlaceholderText = ({
  i18n,
  tenant,
  defaultPlaceholderText,
}: {
  i18n: I18n
  tenant: string
  defaultPlaceholderText: string
}) => {
  if ([TENANT_AT, TENANT_COM, TENANT_FR, TENANT_IT].includes(tenant)) {
    return i18n._('general.label.placeholder.searchYourProduct')
  } else {
    return defaultPlaceholderText
  }
}
